import React, { useState, useEffect, useRef } from "react";
import "../Dashboard/styles.css";
import { Link, useNavigate } from "react-router-dom";

export default function Navbar() {
  const [accountDropdownOpen, setAccountDropdownOpen] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(""); // Initialize with an empty string
  const accountDropdownRef = useRef(null);

  const toggleAccountDropdown = () => {
    setAccountDropdownOpen(!accountDropdownOpen);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (accountDropdownRef.current && !accountDropdownRef.current.contains(event.target)) {
        setAccountDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const navigate = useNavigate();

  const handleLogout = () => {
    console.log("Logging out...");
    localStorage.removeItem('loggedInUser');
    navigate('/');
  };

  useEffect(() => {
    // Fetch the username from local storage
    const storedUsername = localStorage.getItem('loggedInUser');
    if (storedUsername) {
      setLoggedInUser(storedUsername);
    }

    
  }, []);

  return (
    <div className="dashboard-header sticky-header">
      {/* ... */}
      <div className="content-left logo-section pull-left">
        <h1>
          <a href="/">
            <img
              src="https://res.cloudinary.com/debltnmge/image/upload/v1692303746/JourneyScape_dhgong.webp"
              alt="logo"
              className="logo-img"
            />
          </a>
        </h1>
      </div>
      <div className="heaer-content-right pull-right">
        <div
          id="dropdown2"
          ref={accountDropdownRef}
          className={`dropdown ${accountDropdownOpen ? "show" : ""}`}
        >
          <Link
            path="#"
            className="dropdown-toggle"
            onClick={toggleAccountDropdown}
            aria-haspopup="true"
            aria-expanded={accountDropdownOpen}
          >
            <div className="dropdown-item profile-sec">
              {loggedInUser}
            </div>
          </Link>
          <div
            id="dropdown"
            className={`dropdown-menu account-menu ${accountDropdownOpen ? "show" : ""}`}
          >
            <ul>
              <li>
                <button className="nav-link" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt" style={{ fontSize: "16px", padding: "15px"}} /> Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
        {/* ... */}
      </div>
    </div>
  );
}
